import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PackagePlus } from 'lucide-react';
import { Botao } from '../../componentes/base';
import { Vazio } from '../../componentes/estados';
import { Tabela, type Coluna } from '../../componentes/tabela';
import { dinheiro, nomePessoa } from '../../nucleo/formato';
import { useSessao } from '../../nucleo/sessao';
import { qtd } from './comum';
import { FormMovimentacao, type ProdutoParaMovimento } from './Movimentacoes';
import type { Reposicao as ItemReposicao } from './tipos';

/** M9.4: produtos abaixo do mínimo com sugestão de compra (mínimo x 2 menos o saldo). */
export function Reposicao() {
  const { t } = useTranslation('estoque');
  const s = useSessao();
  const [receber, setReceber] = useState<{ produto: ProdutoParaMovimento; quantidade: number } | null>(null);

  const colunas: Coluna<ItemReposicao>[] = [
    { chave: 'codigo', rotulo: t('campos.codigo'), mono: true },
    {
      chave: 'nome',
      rotulo: t('campos.nome'),
      principal: true,
      ordenavel: true,
      render: (r) => (
        <span className="flex min-w-0 flex-col">
          <span className="truncate font-medium" title={r.nome}>{r.nome}</span>
          {r.fornecedor_nome && <span className="truncate text-xs text-tinta-3" title={nomePessoa(r.fornecedor_nome)}>{nomePessoa(r.fornecedor_nome)}</span>}
        </span>
      ),
    },
    { chave: 'saldo', rotulo: t('campos.saldo'), alinhar: 'direita', mono: true, render: (r) => <span className="text-laranja">{`${qtd(r.saldo)} ${r.unidade}`}</span> },
    { chave: 'estoque_minimo', rotulo: t('campos.minimo'), alinhar: 'direita', mono: true, render: (r) => qtd(r.estoque_minimo) },
    { chave: 'falta', rotulo: t('reposicao.falta'), alinhar: 'direita', mono: true, render: (r) => qtd(r.falta) },
    { chave: 'sugestao_compra', rotulo: t('reposicao.sugestao'), alinhar: 'direita', mono: true, render: (r) => <span className="font-semibold">{`${qtd(r.sugestao_compra)} ${r.unidade}`}</span> },
    { chave: 'custo_estimado_centavos', rotulo: t('reposicao.custoEstimado'), alinhar: 'direita', mono: true, render: (r) => dinheiro(r.custo_estimado_centavos) },
    {
      chave: 'acoes',
      rotulo: '',
      render: (r) =>
        s.pode('estoque.movimentar') ? (
          <Botao
            tamanho="sm"
            icone={<PackagePlus className="size-4" />}
            onClick={(e) => {
              e.stopPropagation();
              setReceber({ produto: { id: r.id, codigo: r.codigo, nome: r.nome, unidade: r.unidade, custo_centavos: r.custo_centavos, controla_lote: r.controla_lote }, quantidade: r.sugestao_compra });
            }}
          >
            {t('acoes.registrarEntrada')}
          </Botao>
        ) : null,
    },
  ];

  return (
    <>
      <p className="mb-3 text-sm text-tinta-3">{t('reposicao.explicacao')}</p>
      <Tabela<ItemReposicao>
        tela="estoque.reposicao"
        caminho="/estoque/reposicao"
        colunas={colunas}
        vazio={<Vazio titulo={t('reposicao.tudoEmDia')} texto={t('reposicao.tudoEmDiaTexto')} />}
      />
      <FormMovimentacao aberto={!!receber} aoFechar={() => setReceber(null)} produto={receber?.produto} tipoInicial="entrada" quantidadeInicial={receber?.quantidade} />
    </>
  );
}
